<app-messages>
	<div class="selector-size d-flex align-items-center">
		<i class="pointer material-icons text-gray-600" style="width:24px;">comments</i>
		<span *ngIf="sm.unread_total && sm.unread_total > 0"
			class="count-badge d-flex align-items-center justify-content-center badge-red-lighter font-weight-bolder">
			{{ sm.unread_total > 9?'9+':sm.unread_total}}
		</span>
	</div>
</app-messages>
